<template>
  <div class="table-holder table-responsive">
    <select
      class="form-select form-select-sm custom-pagination-rows-in-a-page"
      v-model="customPaginatePerPageElements"
    >
      <option value="10">10</option>
      <option value="20">20</option>
      <option value="30">30</option>
      <option value="40">40</option>
      <option value="50">50</option>
    </select>
    <div class="top-right">
      <slot name="top-right"></slot>
    </div>
    <input
      type="text"
      v-if="searchParams"
      v-model="searchValue"
      placeholder="Search"
      style="
        float: right;
        border: 1px solid rgba(0, 0, 0, 0.125);
        padding: 2px 7px;
        border-radius: 3px;
      "
    />
    <slot />
    <div v-if="searchedFilteredData.length > 0">
      <p class="custom-pagination-pages-status">
        Showing {{ this.customPaginateFrom }} to {{ this.customPaginateTo }} of
        {{ this.searchedFilteredData.length }} entries
      </p>
      <div class="custom-pagination-page-buttons">
        <button
          class="btn btn-light btn-sm"
          @click="
            customPaginateCurrentPage > 1 ? customPaginateCurrentPage-- : null
          "
        >
          <i class="bi bi-chevron-left"></i>
        </button>
        <button
          :class="[
            { btn: true },
            { 'btn-light': customPaginateCurrentPage != pageNum },
            { 'btn-primary': customPaginateCurrentPage == pageNum },
            { 'btn-sm': true }
          ]"
          v-for="pageNum in pagesToShow"
          :key="pageNum"
          @click="customPaginateCurrentPage = pageNum"
        >
          {{ pageNum }}
        </button>
        <!-- <span class="custom-pagination-page-info"
          >{{ customPaginateCurrentPage }} in {{ totalPage }}</span
        > -->
        <button
          class="btn btn-light btn-sm"
          @click="
            customPaginateCurrentPage < totalPage
              ? customPaginateCurrentPage++
              : null
          "
        >
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['filteredData', 'searchParams', 'perPage'],
  data() {
    return {
      customPaginateFrom: 0,
      customPaginateTo: 0,
      customPaginatePerPageElements: this.perPage ? this.perPage : 10,
      customPaginateCurrentPage: 1,
      paginatedData: [],
      totalPaginateButtons: 3,
      searchValue: ''
    };
  },
  mounted() {
    this.calculateCustomPagination();
  },
  watch: {
    searchedFilteredData: function () {
      this.customPaginateCurrentPage = 1;
      this.calculateCustomPagination();
    },
    customPaginatePerPageElements: function () {
      this.customPaginateCurrentPage = 1;
      this.calculateCustomPagination();
    },
    customPaginateCurrentPage: function () {
      this.calculateCustomPagination();
    },
    paginatedFilteredData: function () {
      this.$emit('fetchPaginatedData', this.paginatedFilteredData);
    }
  },
  computed: {
    searchedFilteredData() {
      let searchedData = [];
      if (this.searchParams && this.searchValue) {
        this.filteredData.forEach((data) => {
          for (const param of this.searchParams) {
            let actualData = data;
            param.split('.').forEach((indParam) => {
              if (actualData[indParam]) {
                actualData = actualData[indParam];
              }
            });
            if (
              typeof actualData === 'string' &&
              actualData.toLowerCase().indexOf(this.searchValue.toLowerCase()) >
                -1
            ) {
              searchedData.push(data);
              break;
            }
          }
        });
        return searchedData;
      }
      return this.filteredData;
    },
    paginatedFilteredData() {
      let paginatedData = this.searchedFilteredData;

      if (this.customPaginateFrom > 0 && this.customPaginateTo > 0) {
        paginatedData = paginatedData.slice(
          this.customPaginateFrom - 1,
          this.customPaginateTo
        );
      }

      return paginatedData;
    },
    totalPage() {
      let totalDatas = this.searchedFilteredData.length;
      return Math.ceil(totalDatas / this.customPaginatePerPageElements);
    },
    pagesToShow() {
      let pages = [];
      let missingButtons =
        this.totalPaginateButtons -
        (this.totalPage - this.customPaginateCurrentPage + 1);
      let from =
        missingButtons > 0
          ? this.customPaginateCurrentPage - missingButtons
          : this.customPaginateCurrentPage;
      if (from < 1) {
        from = 1;
      }
      for (let i = from; i <= this.totalPage; i++) {
        pages.push(i);
        if (pages.length >= this.totalPaginateButtons) {
          break;
        }
      }
      return pages;
    }
  },
  methods: {
    calculateCustomPagination() {
      this.customPaginateFrom =
        this.customPaginatePerPageElements *
          (this.customPaginateCurrentPage - 1) +
        1;
      let tempTo =
        this.customPaginatePerPageElements * this.customPaginateCurrentPage;
      if (tempTo > this.searchedFilteredData.length) {
        tempTo = this.searchedFilteredData.length;
      }
      this.customPaginateTo = tempTo;
    }
  }
};
</script>

<style scoped>
.custom-pagination-rows-in-a-page {
  width: 90px;
  float: left;
  margin-bottom: 12px;
}
.custom-pagination-pages-status {
  float: left;
}
.custom-pagination-page-buttons {
  float: right;
}
.custom-pagination-page-buttons button {
  margin-left: 5px;
}
.top-right {
  float: right;
}
</style>
